import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=4e1a5d85&scoped=true"
import script from "./ButtonBase.vue?vue&type=script&lang=js"
export * from "./ButtonBase.vue?vue&type=script&lang=js"
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=4e1a5d85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a5d85",
  null
  
)

export default component.exports